/**
 * Module-level listener set, so anything that changes the notification list can tell an open bell
 * panel to refresh. Same pattern as `utils/loanSubmissionSync`: one bus rather than prop drilling
 * through the header.
 */
type Listener = () => void

const listeners = new Set<Listener>()

export const onNotificationsChanged = (listener: Listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const emitNotificationsChanged = () => {
  listeners.forEach((listener) => {
    try {
      listener()
    } catch {
      // A listener from an unmounting panel must not break the others.
    }
  })
}
